// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-y[data-v-8ea5bb6e]{overflow-y:scroll}", ""]);
// Exports
module.exports = exports;
